import { logUsage } from 'owa-analytics';
import { lazyIsLinkPrefixedWithBaseUrl } from 'owa-sharepoint-link-detector';
import {
    ONE_DRIVE_CONUSMER_BASE_URL,
    MOUSE_MIDDLE_BUTTON,
    OD_LINK_CLICK_EVENT_LISTENER,
    OD_LINK_MOUSEUP_EVENT_LISTENER,
} from './constants';

export async function tryProcessODCLink(
    element: HTMLElement,
    href: string,
    isSafeLinkWrapped: boolean,
    isSafeLinkVerified: boolean
) {
    const isLinkPrefixedWithBaseUrl = await lazyIsLinkPrefixedWithBaseUrl.import();
    if (isLinkPrefixedWithBaseUrl(href, ONE_DRIVE_CONUSMER_BASE_URL)) {
        const eventListener = (ev: MouseEvent) => {
            logODCLinkClick(isSafeLinkWrapped, isSafeLinkVerified);
        };
        element.addEventListener('click', eventListener);
        element[OD_LINK_CLICK_EVENT_LISTENER] = eventListener;

        const mouseupListener = (ev: MouseEvent) => {
            if (ev.button === MOUSE_MIDDLE_BUTTON) {
                // This will open a new tab but not going through the regular click handler
                logODCLinkClick(isSafeLinkWrapped, isSafeLinkVerified);
            }
        };

        element.addEventListener('mouseup', mouseupListener);
        element[OD_LINK_MOUSEUP_EVENT_LISTENER] = mouseupListener;
    }
}

function logODCLinkClick(isSafeLinkWrapped: boolean, isSafeLinkVerified: boolean) {
    logUsage('ODCLinkClick', {
        isSafeLinkWrapped: isSafeLinkWrapped,
        isSafeLinkVerified: isSafeLinkVerified,
    });
}
